import React from "react";

const SimCheckBox = ({ id, label, checked, onChange }) => {
  return (
    <>
      <div className="form-check simcheck">
        <input className="form-check-input" type="checkbox" id={id} checked={checked} onChange={onChange} />
        {label && (
          <label className="form-check-label" htmlFor={id}>
            {label}
          </label>
        )}
      </div>
    </>
  );
};

export default SimCheckBox;
